import type { Worksheet } from "exceljs";
import { PRINT_TITLES_ROW } from "../constants";
import type { WeekStaffScheduleExportPageSetup } from "../types";

type ApplyWeekSchedulePageSetupArgs = {
	worksheet: Worksheet;
	title: string;
	pageSetup: WeekStaffScheduleExportPageSetup;
};

/**
 * A4 print settings for the week-schedule sheet.
 *
 * Deliberately separate from the daily printout's `applyPageSettings`: that one derives orientation
 * from a printout column list we don't have and repeats a four-row header block, while this sheet
 * always carries an explicit orientation from the settings panel and a three-row header.
 */
export const applyWeekSchedulePageSetup = ({ worksheet, title, pageSetup }: ApplyWeekSchedulePageSetupArgs): void => {
	worksheet.pageSetup = {
		paperSize: 9, // A4
		orientation: pageSetup.orientation,
		fitToPage: pageSetup.fitToPage,
		fitToWidth: pageSetup.fitToWidth,
		fitToHeight: pageSetup.fitToHeight,
		margins: { left: 0.4, right: 0.4, top: 0.6, bottom: 0.6, header: 0.3, footer: 0.3 },
		horizontalCentered: true,
		// Keep the title and weekday names visible on every page of a long schedule.
		printTitlesRow: PRINT_TITLES_ROW,
	};

	worksheet.headerFooter = { oddHeader: `&C&B${title}`, oddFooter: "&LPrinted: &D &T&CPage &P of &N" };
};
